<div class="slider-with-btn-wrapper">

  <div class="slider-wrapper">
    <div
      [ngStyle]="{'transform': 'translateX(' + (-currentSlideIndex * 100) + '%'}"
      [style.--slide-count]="slides.length"
      class="slider"
    >

      @for (slide of slides; track slide) {

        @if (slide.imageDesktop && slide.imageMobile) {
          <img class="show-only-desktop" src="{{slide.imageDesktop}}" alt="image slider"/>
          <img class="show-only-mobile" src="{{slide.imageMobile}}" alt="image slider"/>
        } @else {
          <div class="slide" [ngStyle]="{'background-color': slide.color}">
            title {{slide.title}}
          </div>
        }
      }

    </div>
  </div>

  <div class="btns">
    @for (slideIndex of slides.keys(); track slideIndex) {
      <button
        (click)="onSelectedSlide(slideIndex)"
        [ngClass]="{'btn-selected': currentSlideIndex === slideIndex}"
      ></button>
    }
  </div>

  <div class="btns-fleche">
    <button
      (click)="onPrevSlide()"
    ><</button>
    <button
      (click)="onNextSlide()"
    >></button>
  </div>

</div>
